import React from 'react';
import * as properties from '../../elementsPropertiesItems';
import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const Alignment = (props)=>{
    const {path,keyParam,alignTypes,elementData} = props;
    const alignValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'left':'left';    
    return(
        <>
           <div className="selectgroup selectgroup-info">
                {
                    properties.AlignmentTypes.map((item,itemIndex)=>{
                        let isChecked = false;
                        if(item.value === alignValue){
                           isChecked = true; 
                        }

                        if(isSet(alignTypes,[]).indexOf(item.value)==-1){
                            return false;
                        }
                        return(
                            <label className="selectgroup-item" key={itemIndex}> 
                                <input type="radio" name="alignment" value={item.value} checked={isChecked} className="selectgroup-input" onChange={()=>props.changeHandler(path,keyParam,item.value)}/>
                                <span className="selectgroup-button">
                                    <Icons iconType="Alignment" alignType={item.value} />
                                </span>
                            </label>
                        )
                    })
                }
            </div>
        </>
    )
}

export default Alignment;